import { render, staticRenderFns } from "./zDialogo.vue?vue&type=template&id=fa6814f6&scoped=true"
import script from "./zDialogo.vue?vue&type=script&lang=js"
export * from "./zDialogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6814f6",
  null
  
)

export default component.exports